module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('theme-provider'), _c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "rounded": "0",
      "color": "background"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "white",
      "dark": "",
      "flat": ""
    },
    scopedSlots: _vm._u([{
      key: "extension",
      fn: function() {
        return [_c('v-tabs', {
          attrs: {
            "align-with-title": "",
            "background-color": "primary"
          },
          model: {
            value: (_vm.tab),
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        }, [_c('v-tabs-slider', {
          attrs: {
            "color": "white"
          }
        }), _vm._l((_vm.menu), function(item, index) {
          return _c('v-tab', {
            key: item.key,
            attrs: {
              "to": item.path
            }
          }, [_vm._v(_vm._s(item.name))])
        })], 2)]
      },
      proxy: true
    }])
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-700"
  }, [_c('v-list', {
    attrs: {
      "dense": "dense",
      "color": "white"
    }
  }, [_c('v-list-item', {
    attrs: {
      "to": "/",
      "active-class": "white white--text"
    }
  }, [_c('v-list-item-title', [_c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/logo.png",
      "width": "150"
    }
  }), _c('v-spacer'), _c('v-chip', {
    staticClass: "ml-3",
    attrs: {
      "color": "primary",
      "small": "small"
    }
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Help Desk")])])], 1)])], 1)], 1)], 1), _c('v-spacer'), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-chip', _vm._g(_vm._b({
          staticClass: "pa-4",
          attrs: {
            "color": "background  black--text"
          }
        }, 'v-chip', attrs, false), on), [_c('v-avatar', {
          attrs: {
            "left": "left"
          }
        }, [_c('avatar-perfil', {
          attrs: {
            "usuario": _vm.username,
            "is-fetch": true
          }
        })], 1), _c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(_vm.nombre))])], 1)]
      }
    }])
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Perfil de tu cuenta")])]), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-2",
          attrs: {
            "fab": "",
            "dark": "",
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.logout()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("logout")])], 1)]
      }
    }])
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Cerrar sesión")])])], 1), _c('v-tabs-items', [_c('div', {
    staticClass: "calc-height background"
  }, [_c('router-view')], 1), _c('notifications', {
    class: _vm.isMovil ? 'width-full' : '',
    attrs: {
      "position": "top right"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('v-alert', {
          staticClass: "elevation-2 py-3 ma-1 animated fadeInRight faster",
          attrs: {
            "dense": "dense",
            "border": "left",
            "type": props.item.type
          }
        }, [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "grow"
        }, [_c('small', {
          staticClass: "font-size-11 font-weight-700"
        }, [_vm._v(_vm._s(props.item.text))])])], 1)], 1)]
      }
    }])
  }), (_vm.transaction.isProceso) ? _c('loading-transaction', {
    attrs: {
      "label": _vm.transaction.message
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c935e78","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Admin_App.vue
// module id = 490
// module chunks = 1